export default __webpack_public_path__ + "static/media/Partners Logos-01.aac0a80c.jpg";